import { dialog, Button } from "nq-component";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Table from "../../../components/Table";
import CardView from "../../../components/common/CardView";
import Search from "../../../components/Search";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import NoticesPresenter from "./NoticesPresenter";
import BaseListPage from "../../../base/BaseListPage";
import InputFactory from "../../../components/InputFactory";
import Progress from "../../../components/Progress";
class NoticesPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new NoticesPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );

    this.state = {
      description: "",
      sendToAll: false,
      offices: [],
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
      // fields: {}
    };
  }

  // delete function
  async handleDeleteData(id) {
    await this.presenter.deleteObjectUseCase.execute(
      this.getCollectionName(),
      id,
    );
    this.refetchData();
  }

  // edit function
  async handleEditData(object) {
    this.navigateTo(`/form/${this.getCollectionName()}/${object.id}`);
    // this.refetchData();
  }

  handleViewData(object) {
    this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  getCollectionName() {
    return "notices";
  }

  addNotices() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  submitMe() {
    upsertUseCase().execute(this.getCollectionName(), this.state);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Human Resource {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.collection}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                {/* <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                /> */}
                <div className="d-flex mb-1">
                  {Object.keys(schema.filters || {}).map((field) => {
                    let { type, ...options } = schema.filters[field];
                    return (
                      <InputFactory
                        key={field}
                        className="ms-1"
                        type={type}
                        field={field}
                        where={{}}
                        onChange={this.onChangeFilter.bind(this, type)}
                        {...options}
                      />
                    );
                  })}
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.addNotices.bind(this)}>
                        <i className="bi bi-plus-lg" /> New {schema.collection}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                // objectId={this.handleDeleteData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                objectId={this.handleViewData.bind(this)}
                objectData={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "delete",
                  },
                  {
                    label: <i className="bi bi-pencil-square"> Edit</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "template",
                    "description",
                    "sendToAll",
                    "employee",
                  ],
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(NoticesPage);
